import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blueCancel",
  "use": "blueCancel-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"blueCancel\"><g data-name=\"icon - cancel - 12px\" transform=\"translate(-340 -671)\"><circle cx=\"6\" cy=\"6\" r=\"6\" transform=\"translate(340 671)\" fill=\"#031425\" /><g data-name=\"↳color\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\".75\"><path data-name=\"Line 152\" d=\"M347.414 675.586l-2.828 2.828\" /><path data-name=\"Line 153\" d=\"M344.586 675.585l2.829 2.828\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol